export const listaIdiomas = [
  { id: 'pt-BR', label: 'pt-BR — Português (Brasil)' },
  { id: 'en-US', label: 'en-US — English (United States)' },
  { id: 'de-DE', label: 'de-DE — Deutsch (Alemanha)' },
  { id: 'da-DK', label: 'da-DK — Dansk (Dinamarca)' },
  { id: 'es-ES', label: 'es-ES — Español (Espanha)' },
  { id: 'fi-FI', label: 'fi-FI — Suomi (Finlândia)' },
  { id: 'fr-FR', label: 'fr-FR — Français (França)' },
  { id: 'el-GR', label: 'el-GR — Ελληνικά (Grécia)' },
  { id: 'nl-NL', label: 'nl-NL — Nederlands (Países Baixos)' },
  { id: 'hu-HU', label: 'hu-HU — Magyar (Hungria)' },
  { id: 'it-IT', label: 'it-IT — Italiano (Itália)' },
  { id: 'nb-NO', label: 'nb-NO — Norsk (Noruega)' },
  { id: 'pl-PL', label: 'pl-PL — Polski (Polônia)' },
  { id: 'pt-PT', label: 'pt-PT — Português (Portugal)' },
  { id: 'ro-RO', label: 'ro-RO — Română (Romênia)' },
  { id: 'ru-RU', label: 'ru-RU — Русский (Rússia)' },
  { id: 'sv-SE', label: 'sv-SE — Svenska (Suécia)' },
  { id: 'cs-CZ', label: 'cs-CZ — Čeština (República Checa)' },
  { id: 'tr-TR', label: 'tr-TR — Türkçe (Turquia)' },
  { id: 'uk-UA', label: 'uk-UA — Українська (Ucrânia)' }
]
